export default {
  namespaced: true,
  state: {
    crumbs: null
  },
  mutations: {
    SET_CRUMBS (state, items) {
      state.crumbs = items
    },
    CLEAR_CRUMBS (state) {
      state.crumbs = null
    }
  }
}
